import styled, { css, keyframes } from 'styled-components';
import { Link as ReactLink } from 'react-router-dom';

import fadeIn from 'react-animations/lib/fade-in';
import fadeOut from 'react-animations/lib/fade-out';

const fadeInAnimation = keyframes`${fadeIn}`;
const fadeOutAnimation = keyframes`${fadeOut}`;

export const Holder = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const Button = styled.a`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
`;

export const Name = styled.span`
  display: inline-block;
  margin: 0 15px 0 0;
  transition: 0.2s all;
  color: ${(props) => props.theme.color};
  font-size: 16px;
  font-weight: 500;

  &:hover,
  ${Button}:hover & {
    color: ${(props) => props.theme.colorOnHover};
  }
`;

export const AvatarHolder = styled.div`
  display: flex;
  width: 55px;
  height: 55px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  flex-shrink: 0;
  border: 2px solid ${(props) => props.theme.border};
  overflow: hidden;
`;

export const Avatar = styled.img`
  display: block;
  width: 45px;
  height: 45px;
  object-fit: cover;
  border-radius: 15px;
  flex-shrink: 0;
  background: ${(props) => props.theme.background};
`;

export const AvatarPlaceholder = styled.div`
  display: block;
  width: 45px;
  height: 45px;
  object-fit: cover;
  border-radius: 15px;
  flex-shrink: 0;
  background: ${(props) => props.theme.background};
`;

export const Content = styled.div`
  position: absolute;
  display: none;
  top: 100%;
  right: 0;
  width: 162px;
  margin: 5px 0 0 0;
  padding: 0;
  border-radius: 5px;
  border: 1px solid ${(props) => props.theme.border};
  background: ${(props) => props.theme.background};
  box-shadow: 0 0 6px 0px ${(props) => props.theme.shadow};
  z-index: 3;
  overflow: hidden;
  opacity: 1;

  ${(props) =>
    props.open &&
    css`
      animation: 0.1s ${fadeInAnimation};
    `}

  ${(props) =>
    props.close &&
    css`
      opacity: 0;
      animation: 0.1s ${fadeOutAnimation};
    `}

    ${(props) =>
      props.visible &&
      css`
        display: block;
      `}
`;

export const Item = styled.a`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 45px;
  transition: 0.2s all;
  padding: 0;
  background: ${(props) => props.theme.background};
  color: ${(props) => props.theme.color};
  font-size: 17px;
  font-weight: 500;
  text-align: center;
  user-select: none;
  cursor: pointer;

  &:after {
    position: absolute;
    width: auto;
    height: 1px;
    background: ${(props) => props.theme.backgroundLine};
    right: 10px;
    left: 10px;
    bottom: 0;
    z-index: +1;
    content: '';
  }

  &:last-child:after {
    display: none;
  }

  &:hover {
    background: ${(props) => props.theme.backgroundOnHover};
    color: ${(props) => props.theme.colorOnHover};
  }
`;

export const ItemLink = styled(ReactLink)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 45px;
  transition: 0.2s all;
  padding: 0;
  background: ${(props) => props.theme.background};
  color: ${(props) => props.theme.color};
  font-size: 17px;
  font-weight: 500;
  text-align: center;
  user-select: none;
  cursor: pointer;

  &:after {
    position: absolute;
    width: auto;
    height: 1px;
    background: ${(props) => props.theme.backgroundLine};
    right: 10px;
    left: 10px;
    bottom: 0;
    z-index: +1;
    content: '';
  }

  &:last-child:after {
    display: none;
  }

  &:hover {
    background: ${(props) => props.theme.backgroundOnHover};
    color: ${(props) => props.theme.colorOnHover};
  }
`;
